<template>
    <md-card class="md-elevation-7">
        <md-card-header class="md-elevation-5" :data-background-color="dataBackgroundColor">
            <slot name="header"></slot>
        </md-card-header>

        <md-card-content>
            <slot name="content"></slot>
        </md-card-content>

        <md-card-actions md-alignment="left" class="footer">
            <slot name="footer"></slot>
        </md-card-actions>
    </md-card>
</template>

<script>
export default {
  name: 'stats-card',
  props: {
    dataBackgroundColor: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
    [data-background-color="purple"],
    .md-tabs.md-primary .md-tabs-navigation{
        background: #7C4DFF;
    }

    [data-background-color="blue"],
    .md-tabs.md-info .md-tabs-navigation{
        background: #448AFF;
    }

    [data-background-color="pink"],
    .md-tabs.md-info .md-tabs-navigation{
        background: #E040FB;
    }

    [data-background-color="green"],
    .md-tabs.md-success .md-tabs-navigation{
        background: #4CAF50;
    }

    [data-background-color="orange"],
    .md-tabs.md-warning .md-tabs-navigation{
        background: #FFAB40;
    }

    [data-background-color="brown"],
    .md-tabs.md-warning .md-tabs-navigation{
        background: #8D6E63;
    }

    [data-background-color="yellow"],
    .md-tabs.md-warning .md-tabs-navigation{
        background: #FFFF00;
    }

    [data-background-color="red"],
    .md-tabs.md-danger .md-tabs-navigation{
        background: #FF6E40;
    }
    
    small{
        color: gray;
        font-size: 65%;
        line-height: 1;
        font-weight: 400;
    }

    .category{
		margin: 0;
        padding-top: 15px;
		color: #999;
	}

	.title{
		color: black;
		font-size: 200%;
		line-height: 1;
		font-weight: 400;
	}

    .footer{
        border-top-width: 1px;
        border-top-color: lightgray;
        border-top-style: solid;
        margin-left: 20px;
        margin-right: 20px;
    }

    .md-card-header{
        float: left;
        text-align: center;
        font-size: 36px !important;
        line-height: 56px;
        width: 90px;
        height: 90px;
        color: white !important;
        margin-top: -15px;
        margin-left: 15px;
    }

    .md-card-content{
        text-align: right;
        padding-top: 10px;
    }

    .stats{
        line-height: 22px;
        color: lightgray;
        font-size: small;
        margin-left: -5px;
    }

    .md-icon.md-theme-default.md-icon-font{
        position: relative;
        top: -1px;
    }
</style>



// WEBPACK FOOTER //
// src/components/StatsCard.vue